export const PAYMENT_EVENT_SOURCE = 'payment_iframe'
export const PAYMENT_EVENT_NAME = 'on_payment_finished'

export const PAYMENT_REDIRECT_PAGE_PATH = '/r/:uuid'
